<template>
  <picture class="picture" v-if="width" :key="imgM + img">
    <source type="image/webp" :srcset="$ossWebp(isMobile ? imgM || img : img, noCompress ? false : { width: width, height: height })" />
    <img
      class="img"
      :style="`object-fit:${objectFit || 'cover'}`"
      :src="$ossJpg(isMobile ? imgM || img : img, noCompress ? false : { width: width, height: height })"
      @load="onLoad"
      loading="lazy"
    />
  </picture>
</template>
<script>
export default {
  props: {
    img: String,
    imgM: String,
    wm: [Number, String],
    w: [Number, String],
    h: [Number, String],
    hm: [Number, String],
    fullScreen: Boolean,
    objectFit: String,
    noCompress: Boolean,
  },
  data() {
    return {
      width: 0,
      height: 0,
    };
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobileSite;
    },
  },
  methods: {
    onLoad() {
      this.$emit("load");
    },
  },
  mounted() {
    if (this.isMobile) {
      this.width = (this.wm || this.w) * window.devicePixelRatio;
      this.height = (this.hm || this.h) * window.devicePixelRatio;
    } else {
      this.width = this.w * window.devicePixelRatio;
      this.height = this.h * window.devicePixelRatio;
    }
    if (this.fullScreen) {
      this.height = this.height * (window.innerWidth / this.width);
      this.width = window.innerWidth;
    }
  },
};
</script>

<style scoped lang="less">
.picture {
  display: block;
  img {
    width: 100%;
    height: 100%;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Picture.vue